import { RemoteFileLoader } from '@amzn/ihm-associate-tools-js-lib'

// const FEATURE_CONFIG_URL = '/remote/ihm-associate-platform/feature-configs/feature-configs.json'
// Uncomment below for local testing
const FEATURE_CONFIG_URL = 'https://menczphd73.execute-api.us-west-2.amazonaws.com/feature-configs'

export async function getFeatureConfig (): Promise<any> {
    return RemoteFileLoader.loadJson({ url: FEATURE_CONFIG_URL })
}
